export enum CORE_INVITES_IN_JIRA_PROJECTS {
	CONTROL = 'control',
	NOT_ENROLLED = 'not-enrolled',
	INVITE_ONLY = 'invite-only-variation',
	INVITE_ONLY_NOT_ENROLLED = 'invite-only-not-enrolled',
	INVITE_RA = 'invite-ra-variation',
	INVITE_RA_NOT_ENROLLED = 'invite-ra-variation',
}

export type CoreInvitesInJiraProjectsCohort =
	| CORE_INVITES_IN_JIRA_PROJECTS.NOT_ENROLLED
	| CORE_INVITES_IN_JIRA_PROJECTS.CONTROL
	| CORE_INVITES_IN_JIRA_PROJECTS.INVITE_ONLY
	| CORE_INVITES_IN_JIRA_PROJECTS.INVITE_ONLY_NOT_ENROLLED
	| CORE_INVITES_IN_JIRA_PROJECTS.INVITE_RA
	| CORE_INVITES_IN_JIRA_PROJECTS.INVITE_RA_NOT_ENROLLED;
